module.exports = __webpack_public_path__ + "fonts/Gotham-Ultra.c3f27c59.otf";